export * from 'utils/scrollObserver.js';
// import * as base from 'utils/scrollObserver.js';
import cached from 'utils/cached';
import Store from 'store/store';

let client = Store.get().client;
let isMobile = (client && !client.isDesktopSize);

let rootMargin = isMobile ? '0px 0px 0px 0px' : '0px 0px -33% 0px';

const elementOptions = new WeakMap();

const getObserver = cached(() => new IntersectionObserver(onUpdate, { rootMargin: rootMargin }));

export function observeScroll(el, options = {}) {
	try {
		elementOptions.set(el, options);
		getObserver().observe(el);
	} catch (e) {
		console.warn(e);
		// do nothing
	}
}

export function unobserveScroll(el) {
	try {
		elementOptions.delete(el);
		getObserver().unobserve(el);
	} catch (e) {
		console.warn(e);
		// do nothing
	}
}

function onUpdate(entries, observer) {
	entries.forEach(entry => {
		const scrolledPast = entry.boundingClientRect.top <= (entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight);
		entry.target.toggleAttribute('scrolled-past', scrolledPast);

		const options = elementOptions.get(entry.target);
		if (options && options.once && scrolledPast) {
			observer.unobserve(entry.target);
			elementOptions.delete(entry.target);
		}
	});
}

Store.on('UPDATE_CLIENT', () => {
	client = Store.get().client;
	isMobile = (client && !client.isDesktopSize);
	rootMargin = isMobile ? '0px 0px 0px 0px' : '0px 0px -33% 0px';
});